'use client';

import React from 'react';
import HeroSection from './HeroSection';
import JourneyTimeline from './JourneyTimeline';
import PhilosophySection from './PhilosophySection';
import SkillsExpertise from './SkillsExpertise';
import CulturalInspiration from './CulturalInspiration';
import TestimonialsCarousel from './TestimonialsCarousel';
import PersonalInterests from './PersonalInterests';
import CTASection from './CTASection';

interface TimelineEvent {
  year: string;
  title: string;
  description: string;
  icon: string;
}

interface PhilosophyPrinciple {
  icon: string;
  title: string;
  description: string;
}

interface Skill {
  name: string;
  level: number;
  category: string;
}

interface InspirationItem {
  title: string;
  description: string;
  image: string;
  imageAlt: string;
}

interface Testimonial {
  id: number;
  name: string;
  role: string;
  company: string;
  image: string;
  imageAlt: string;
  quote: string;
  result: string;
}

interface Interest {
  icon: string;
  title: string;
  description: string;
}

interface AboutInteractiveProps {
  heroData: {
    name: string;
    tagline: string;
    description: string;
    image: string;
    imageAlt: string;
  };
  timelineEvents: TimelineEvent[];
  philosophyPrinciples: PhilosophyPrinciple[];
  skills: Skill[];
  inspirations: InspirationItem[];
  testimonials: Testimonial[];
  interests: Interest[];
}

const AboutInteractive = ({
  heroData,
  timelineEvents,
  philosophyPrinciples,
  skills,
  inspirations,
  testimonials,
  interests,
}: AboutInteractiveProps) => {
  return (
    <>
      <HeroSection data-component-id="src/app/about/components/AboutInteractive.tsx:83:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="83" data-component-end-line="83" data-component-file="AboutInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...heroData} />
      <JourneyTimeline data-component-id="src/app/about/components/AboutInteractive.tsx:84:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="84" data-component-end-line="84" data-component-file="AboutInteractive.tsx" data-component-name="JourneyTimeline" data-component-content="%7B%22elementName%22%3A%22JourneyTimeline%22%7D" events={timelineEvents} />
      <PhilosophySection data-component-id="src/app/about/components/AboutInteractive.tsx:85:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="85" data-component-end-line="85" data-component-file="AboutInteractive.tsx" data-component-name="PhilosophySection" data-component-content="%7B%22elementName%22%3A%22PhilosophySection%22%7D" principles={philosophyPrinciples} />
      <SkillsExpertise data-component-id="src/app/about/components/AboutInteractive.tsx:86:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="86" data-component-end-line="86" data-component-file="AboutInteractive.tsx" data-component-name="SkillsExpertise" data-component-content="%7B%22elementName%22%3A%22SkillsExpertise%22%7D" skills={skills} />
      <CulturalInspiration data-component-id="src/app/about/components/AboutInteractive.tsx:87:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="87" data-component-end-line="87" data-component-file="AboutInteractive.tsx" data-component-name="CulturalInspiration" data-component-content="%7B%22elementName%22%3A%22CulturalInspiration%22%7D" inspirations={inspirations} />
      <TestimonialsCarousel data-component-id="src/app/about/components/AboutInteractive.tsx:88:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="88" data-component-end-line="88" data-component-file="AboutInteractive.tsx" data-component-name="TestimonialsCarousel" data-component-content="%7B%22elementName%22%3A%22TestimonialsCarousel%22%7D" testimonials={testimonials} />
      <PersonalInterests data-component-id="src/app/about/components/AboutInteractive.tsx:89:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="89" data-component-end-line="89" data-component-file="AboutInteractive.tsx" data-component-name="PersonalInterests" data-component-content="%7B%22elementName%22%3A%22PersonalInterests%22%7D" interests={interests} />
      <CTASection data-component-id="src/app/about/components/AboutInteractive.tsx:90:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="90" data-component-end-line="90" data-component-file="AboutInteractive.tsx" data-component-name="CTASection" data-component-content="%7B%22elementName%22%3A%22CTASection%22%7D" />
    </>
  );
};

export default AboutInteractive;